import { useState } from 'react';
import { Check, Plus, X } from '@phosphor-icons/react';
import { ImmoButton, InnenKarte, KartenTitel, SchalterZeile, ToastPill, useToastPill } from '../../../../../components/immobilien/ui';
import { AUSSTATTUNG_OPTIONEN, ausstattungListe, ausstattungUmschalten } from '../../../../../lib/immobilien/einheitDetail';
import { supabase } from '../../../../../lib/supabase/client';
import { MERKMAL_ICON } from '../EinheitWidgets';
import { useEinheitSeite } from '../EinheitSeitenKontext';

/**
 * „Ausstattung“: dieselben Merkmale wie im Einheiten-Formular, sofort gespeichert in
 * objekt_einheiten.ausstattung (kommagetrennter Text). Eigene Merkmale bleiben erhalten.
 */
export function AusstattungBereich() {
  const s = useEinheitSeite();
  const [text, setText] = useState<string>(s.daten.einheit.ausstattung ?? '');
  const [neu, setNeu] = useState('');
  const [laeuft, setLaeuft] = useState(false);
  const [toast, zeige] = useToastPill();
  const liste = ausstattungListe(text);
  const eigene = liste.filter(m => !(AUSSTATTUNG_OPTIONEN as readonly string[]).includes(m));

  const speichere = async (naechster: string, meldung: string) => {
    const vorher = text;
    setText(naechster);
    setLaeuft(true);
    const { error } = await supabase.from('objekt_einheiten').update({ ausstattung: naechster || null }).eq('id', s.daten.einheit.id);
    setLaeuft(false);
    if (error) { setText(vorher); zeige(`Nicht gespeichert: ${error.message}`, true); return; }
    zeige(meldung);
    s.geaendert('einheit');
  };

  const umschalten = (m: string) => { if (!laeuft) void speichere(ausstattungUmschalten(text, m), liste.includes(m) ? `${m} entfernt` : `${m} hinzugefügt`); };
  const eigenesHinzu = () => {
    const m = neu.replace(/,/g, ' ').trim();
    if (!m || liste.includes(m)) { setNeu(''); return; }
    setNeu('');
    void speichere(ausstattungUmschalten(text, m), `${m} hinzugefügt`);
  };

  return (
    <>
      {toast && <ToastPill text={toast.text} fehler={toast.fehler} />}
      <InnenKarte>
        <KartenTitel rechts={`${liste.length} ${liste.length === 1 ? 'Merkmal' : 'Merkmale'}`}>Merkmale</KartenTitel>
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(min(240px,100%),1fr))', gap: 8 }}>
          {AUSSTATTUNG_OPTIONEN.map(m => (
            <SchalterZeile key={m} label={m} icon={MERKMAL_ICON[m] ?? Check} an={liste.includes(m)} onChange={() => umschalten(m)} />
          ))}
        </div>
      </InnenKarte>
      <InnenKarte>
        <KartenTitel>Weitere Merkmale</KartenTitel>
        {eigene.length > 0 && (
          <div className="flex flex-wrap" style={{ gap: 8 }}>
            {eigene.map(m => (
              <span key={m} className="flex items-center" style={{ height: 32, padding: '0 6px 0 12px', borderRadius: 16, gap: 6, fontSize: 13, fontWeight: 600, background: 'var(--fill2)' }}>
                {m}
                <button type="button" aria-label={`${m} entfernen`} onClick={() => umschalten(m)} className="flex items-center justify-center cursor-pointer"
                  style={{ width: 22, height: 22, borderRadius: '50%', border: 'none', background: 'transparent', color: 'var(--ink3)' }}><X size={12} weight="bold" /></button>
              </span>
            ))}
          </div>
        )}
        <form className="flex flex-wrap" style={{ gap: 8 }} onSubmit={e => { e.preventDefault(); eigenesHinzu(); }}>
          <input value={neu} onChange={e => setNeu(e.target.value)} placeholder="z. B. Glasfaser, Laminat …" aria-label="Eigenes Merkmal"
            style={{ flex: '1 1 220px', height: 44, borderRadius: 14, padding: '0 14px', border: 'none', outline: 'none', background: 'var(--bg)', boxShadow: 'inset 0 0 0 1px var(--line)', fontSize: 14, color: 'var(--ink)' }} />
          <ImmoButton type="submit" groesse={44} pille={false} icon={Plus} disabled={!neu.trim() || laeuft}>Hinzufügen</ImmoButton>
        </form>
      </InnenKarte>
    </>
  );
}
